import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {ThingFeatureLoopInterface} from '@app/app/shared/interfaces/thing/thing-feature-loop.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Component({
  templateUrl: './park-feature-loop-item.html',
  selector: 'park-feature-loop-item'
})

export class ParkFeatureLoopItemComponent implements OnDestroy{
  @Input() public featureloop: ThingFeatureLoopInterface;
  @Input() public parkId: any;
  @Input() public id: any;
  @Input() public featureloopId: any;

  public isRunningAuto = false;
  public isRunningManual = false;
  public isRunningOff = false;
  public isRunningBypass = false;
  public isRunningReset = false;

  private timerSub: Subscription;

  private MODE_AUTO = 'auto';
  private MODE_MANUAL = 'manu';
  private MODE_OFF = 'off';
  private MODE_BYPASS = 'bypass';
  private MODE_RESET = 'reset';

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  /**
   * Set mode to auto
   */
  public setModeAuto() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningAuto = true;
      this.update(this.MODE_AUTO);
    }
  }

  /**
   * Set mode to manual
   */
  public setModeManual() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningManual = true;
      this.update(this.MODE_MANUAL);
    }
  }

  /**
   * Set mode to off
   */
  public setModeOff() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningOff = true;
      this.update(this.MODE_OFF);
    }
  }

  /**
   * Set mode to bypass
   */
  public setModeBypass() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningBypass = true;
      this.update(this.MODE_BYPASS);
    }
  }

  /**
   * Set mode to reset
   */
  public setModeReset() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningReset = true;
      this.update(this.MODE_RESET);
    }
  }

  public isAuto() {
    const isAuto = (this.featureloop.md === this.MODE_AUTO);

    if (isAuto && this.isRunningAuto) {
      this.isRunningAuto = false;
      this.cdRef.detectChanges();
    }

    return isAuto;
  }

  public isManual() {
    const isManual = (this.featureloop.md === this.MODE_MANUAL);

    if (isManual && this.isRunningManual) {
      this.isRunningManual = false;
      this.cdRef.detectChanges();
    }

    return isManual;
  }

  public isOff() {
    const isOff = (this.featureloop.md === this.MODE_OFF);

    if (isOff && this.isRunningOff) {
      this.isRunningOff = false;
      this.cdRef.detectChanges();
    }

    return isOff;
  }

  public isBypass() {
    const isBypass = (this.featureloop.md === this.MODE_BYPASS);

    if (isBypass && this.isRunningBypass) {
      this.isRunningBypass = false;
      this.cdRef.detectChanges();
    }

    return isBypass;
  }

  public isReset() {
    const isReset = (this.featureloop.md === this.MODE_RESET);

    if (isReset && this.isRunningReset) {
      this.isRunningReset = false;
      this.cdRef.detectChanges();
    }

    return isReset;
  }

  public isRunning() {
    return (this.isRunningAuto || this.isRunningManual || this.isRunningOff || this.isRunningBypass || this.isRunningReset);
  }

  /**
   * Update activator
   */
  private update(mode: string) {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.comm.setFeatureLoopMode(this.parkId, this.id, this.featureloopId, mode).then((res) => {
      this.timerSub = Observable.of(true).delay(15000).subscribe(() => {
        if (this.isRunningAuto && !this.isAuto()) {
          alert('Timed Out');
        }

        if (this.isRunningManual && !this.isManual()) {
          alert('Timed Out');
        }

        if (this.isRunningOff && !this.isOff()) {
          alert('Timed Out');
        }

        if (this.isRunningBypass && !this.isBypass()) {
          alert('Timed Out');
        }

        if (this.isRunningReset && !this.isReset()) {
          alert('Timed Out');
        }

        this.isRunningAuto = false;
        this.isRunningManual = false;
        this.isRunningOff = false;
        this.isRunningBypass = false;
        this.isRunningReset = false;
      });
    }).catch((err) => {
      this.isRunningAuto = false;
      this.isRunningManual = false;
      this.isRunningOff = false;
      this.isRunningBypass = false;
      this.isRunningReset = false;

      alert(err);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/filtration/feature-loop/feature-loop-item/park-feature-loop-item.component.ts